export default "/_next/static/images/18/article2-18277731bc03725702980e5fdeba3d90.jpg";